import React from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getCurrentCompany, getStyle, styleMerge } from '../../utils/utils';
import ManufacturerServiceBookEntryListItem from './ManufacturerServiceBookEntryListItem';
import { connect } from 'react-redux';
import { MultiSelect } from 'primereact/multiselect';
import CBLabelAndCheckbox from '../shared/CBLabelAndCheckbox';
import VehicleListTh from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import RequestServiceHistoryModal from '../VehicleDetailsView/VehicleDetailsComponents/RequestServiceHistoryModal';
import CBButtonGarageAction from '../shared/CBButtonGarageAction';
import { TabMenu } from 'primereact/tabmenu';
import ManufacturerServiceBookHistoryListItem from './ManufacturerServiceBookHistoryListItem';
import { withRouter } from 'react-router-dom';
import ManufacturerServiceBookEntryModal from '../VehicleDetailsView/VehicleDetailsComponents/ManufacturerServiceBookEntryModal';
import RequestServiceEntryModal from '../VehicleDetailsView/VehicleDetailsComponents/RequestServiceEntryModal';
import i18n from '../../i18n';
class ManufacturerServiceBookEntryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: [],
      histories: [],
      loadingHistories: true,
      errorHistories: null,
      loading: true,
      error: null,
      ordering: '-created_at',
      historyOrdering: '-created_at',
      historyFilters: {
      },
      filters: {
        status: ['available', 'in_progress', 'finished']
      },
      fields: [],
      selectedFields: [],
      selectedEntries: [],
      historyFields: [],
      selectedHistoryFields: [],
      selectedHistories: [],
      statusOptions: [
        { label: i18n.t('statusAvailable', { ns: 'ManufacturerServiceBook' }), value: 'available' },
        { label: i18n.t('statusInProgress', { ns: 'ManufacturerServiceBook' }), value: 'in_progress' },
        { label: i18n.t('statusFinished', { ns: 'ManufacturerServiceBook' }), value: 'finished' },
        { label: i18n.t('statusExpired', { ns: 'ManufacturerServiceBook' }), value: 'expired' },
        { label: i18n.t('statusCanceled', { ns: 'ManufacturerServiceBook' }), value: 'canceled' }
      ],
      historyStatusOptions: [
        { label: i18n.t('statusAvailable', { ns: 'ManufacturerServiceBook' }), value: 'available' },
        { label: i18n.t('statusInProgress', { ns: 'ManufacturerServiceBook' }), value: 'in_progress' },
        { label: i18n.t('statusFinished', { ns: 'ManufacturerServiceBook' }), value: 'finished' },
        { label: i18n.t('statusExpired', { ns: 'ManufacturerServiceBook' }), value: 'expired' }
      ],
      selectedTab: 'maintenance-input',
      pollingIntervalId: null,
      manufacturerServiceBookEntryModalIsOpen: false,
      requestServiceHistoryModalIsOpen: false,
      selectedMaintenance: null,
      selectedManufacturerServiceBookEntry: null,
      selectedVehicle: null,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  openRequestServiceHistoryModalClicked = () => {
    const tabName = 'maintenance-history';
    window.history.pushState({}, '', `${window.location.pathname}#${tabName}`);
    this.setState({ requestServiceHistoryModalIsOpen: true, selectedTab: tabName });
  }

  openRequestServiceEntryModalClicked = () => {
    const tabName = 'maintenance-input';
    window.history.pushState({}, '', `${window.location.pathname}#${tabName}`);
    this.setState({ requestServiceEntryModalIsOpen: true, selectedTab: tabName });
  }

  onTabChange = (e) => {
    this.setState({ selectedTab: e.value.id });
    window.history.pushState({}, '', `${window.location.pathname}#${e.value.id}`);
  }

  setSelectedManufacturerServiceBookEntry = (manufacturerServiceBookEntry) => {
    this.setState({ selectedManufacturerServiceBookEntry: manufacturerServiceBookEntry });
  }

  afterRequestServiceEntry = (manufacturerServiceBookEntry) => {
    if (manufacturerServiceBookEntry.maintenance_id) {
      axios.get(`/uiapi/1/vehicle_maintenance/${manufacturerServiceBookEntry.maintenance_id}/`)
      .then(response => {
        this.setState({
          selectedMaintenance: response.data,
          selectedManufacturerServiceBookEntry: manufacturerServiceBookEntry,
          manufacturerServiceBookEntryModalIsOpen: true
        });
      })
    } else {
      this.setState({
        selectedManufacturerServiceBookEntry: manufacturerServiceBookEntry,
        manufacturerServiceBookEntryModalIsOpen: true
      });
    }
  }

  setSelectedMaintenance = (maintenance) => {
    this.setState({ selectedMaintenance: maintenance });
  }

  setSelectedVehicle = (vehicle) => {
    this.setState({ selectedVehicle: vehicle });
  }

  componentWillMount() {
    const { t, location } = this.props;
    const selectedFields = JSON.parse(localStorage.getItem('selectedManufacturerServiceBookFields'));
    const selectedHistoryFields = JSON.parse(localStorage.getItem('selectedManufacturerServiceBookHistoryFields'));

    const allFields = [
      {
        label: t('headingRegistrationNumber', { ns: 'VehicleListView' }),
        value: 'vehicle',
      },
      {
        label: t('headingMaintenance', { ns: 'ManufacturerServiceBook' }),
        value: 'maintenance',
      },
      {
        label: t('headingStatus', { ns: 'TaskListView' }),
        value: 'status',
      },
      {
        label: t('headingExternalStatus', { ns: 'ManufacturerServiceBook' }),
        value: 'external_status',
      },
      {
        label: t('headingDueAt', { ns: 'TaskListView' }),
        value: 'expires_at',
      },
      {
        label: t('headingActions', { ns: 'ManufacturerServiceBook' }),
        value: 'actions',
      },
      {
        label: t('headingInputShowEntry', { ns: 'ManufacturerServiceBook' }),
        value: 'show_entry',
      },
    ];

    this.setState({
      fields: allFields,
      selectedFields: selectedFields || this.getDefaultFields(),
    });

    const allHistoryFields = [
      {
        label: t('headingRegistrationNumber', { ns: 'VehicleListView' }),
        value: 'vehicle',
      },
      {
        label: t('headingStatus', { ns: 'TaskListView' }),
        value: 'status',
      },
      {
        label: t('headingExternalStatus', { ns: 'ManufacturerServiceBook' }),
        value: 'external_status',
      },
      {
        label: t('headingCreatedAt', { ns: 'ManufacturerServiceBook' }),
        value: 'created_at',
      },
    ];

    let selectedTab = 'maintenance-input';
    if (location.hash === '#maintenance-history') {
      selectedTab = 'maintenance-history';
    }

    this.setState({
      historyFields: allHistoryFields,
      selectedHistoryFields: selectedHistoryFields || this.getDefaultHistoryFields(),
      selectedTab: selectedTab,
    });
  }

  getDefaultFields = () => {
    return [
      'vehicle',
      'maintenance',
      'status',
      'external_status',
      'expires_at',
      'actions',
      'show_entry'
    ];
  }

  getDefaultHistoryFields = () => {
    return [
      'vehicle',
      'status',
      'external_status',
      'created_at'
    ];
  }

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { selectedWorkshopId } = this.props;

    if (selectedWorkshopId != prevProps.selectedWorkshopId) {
      this.fetchEntries();
      this.fetchHistories();
    }
  };

  setSelectedFields = (newSelectedFields) => {
    this.setState({
      selectedFields: newSelectedFields,
    });
    localStorage.setItem('selectedManufacturerServiceBookFields', JSON.stringify(newSelectedFields));
  }

  setSelectedHistoryFields = (newSelectedHistoryFields) => {
    this.setState({
      selectedHistoryFields: newSelectedHistoryFields,
    });
    localStorage.setItem('selectedManufacturerServiceBookHistoryFields', JSON.stringify(newSelectedHistoryFields));
  }

  startPolling = () => {
    // Clear any existing interval first
    this.stopPolling();

    // Set up new polling interval
    const intervalId = setInterval(() => {
      this.fetchEntries();
      this.fetchHistories();
    }, 15000); // 15 seconds

    this.setState({ pollingIntervalId: intervalId });
  }

  stopPolling = () => {
    const { pollingIntervalId } = this.state;
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
      this.setState({ pollingIntervalId: null });
    }
  }

  componentDidMount() {
    this.fetchEntries();
    this.fetchHistories();
    this.startPolling();
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    this.stopPolling();
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  fetchEntries = async () => {
    const { selectedWorkshopId, t } = this.props;
    const { ordering, filters } = this.state;

    try {
      this.setState({ loading: true });
      const params = new URLSearchParams();
      params.append('ordering', ordering);
      params.append('workshop_id', selectedWorkshopId);

      // Add status as comma-separated string
      if (filters.status && filters.status.length > 0) {
        params.append('status', filters.status.join(','));
      }

      const response = await axios.get('/uiapi/1/service-book-entries/', { params });
      this.setState({
        entries: response.data,
        loading: false
      });
    } catch (error) {
      this.setState({
        error: t('error', { ns: 'default' }),
        loading: false
      });
    }
  };

  fetchHistories = async () => {
    const { selectedWorkshopId, t } = this.props;
    const { historyOrdering, historyFilters } = this.state;

    const params = new URLSearchParams();
    params.append('ordering', historyOrdering);
    params.append('workshop_id', selectedWorkshopId);

    // Add status as comma-separated string
    if (historyFilters.status && historyFilters.status.length > 0) {
      params.append('status', historyFilters.status.join(','));
    }

    const response = await axios.get('/uiapi/1/service-book-histories/', { params });

    this.setState({
      histories: response.data,
      loadingHistories: false
    });

  }

  changeHistoryOrdering = (clickedOrdering) => {
    const { historyOrdering } = this.state;
    let newHistoryOrdering;
    if (historyOrdering === clickedOrdering) {
      newHistoryOrdering = `-${historyOrdering}`;
    } else if (`-${historyOrdering}` === clickedOrdering) {
      newHistoryOrdering = 'created_at';
    } else {
      newHistoryOrdering = clickedOrdering;
    }
    this.setState({ historyOrdering: newHistoryOrdering }, this.fetchHistories);
  };

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    let newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = `-${ordering}`;
    } else if (`-${ordering}` === clickedOrdering) {
      newOrdering = 'created_at';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({ ordering: newOrdering }, this.fetchEntries);
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  getHistoryOrderingSymbol = (columnName) => {
    const { historyOrdering } = this.state;
    if (historyOrdering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (historyOrdering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  selectEntry = (entryId) => {
    const { selectedEntries } = this.state;
    const newSelectedEntries = selectedEntries.slice();
    newSelectedEntries.push(entryId);
    this.setState({ selectedEntries: newSelectedEntries });
  };

  unselectEntry = (entryId) => {
    const { selectedEntries } = this.state;
    const newSelectedEntries = selectedEntries.filter((item) => item !== entryId);
    this.setState({ selectedEntries: newSelectedEntries });
  };

  selectHistory = (historyId) => {
    const { selectedHistories } = this.state;
    const newSelectedHistories = selectedHistories.slice();
    newSelectedHistories.push(historyId);
    this.setState({ selectedHistories: newSelectedHistories });
  };

  unselectHistory = (historyId) => {
    const { selectedHistories } = this.state;
    const newSelectedHistories = selectedHistories.filter((item) => item !== historyId);
    this.setState({ selectedHistories: newSelectedHistories });
  };

  selectAllHistories = () => {
    const { histories } = this.state;
    const newSelectedHistories = histories.map((history) => history.id);
    this.setState({ selectedHistories: newSelectedHistories });
  };

  unselectAllHistories = () => {
    this.setState({ selectedHistories: [] });
  };

  selectAllEntries = () => {
    const { entries } = this.state;
    const newSelectedEntries = entries.map((entry) => entry.id);
    this.setState({ selectedEntries: newSelectedEntries });
  };

  unselectAllEntries = () => {
    this.setState({ selectedEntries: [] });
  };

  selectAllChanged = () => {
    const { entries } = this.state;
    const { selectedEntries } = this.state;
    const allChecked = selectedEntries.length === entries.length;

    if (allChecked) {
      this.unselectAllEntries();
    } else {
      this.selectAllEntries();
    }
  };

  changeFilterTerms = (value) => {
    this.setState({
      filters: value
    }, this.fetchEntries);
  };

  changeHistoryFilterTerms = (value) => {
    this.setState({
      historyFilters: value
    }, this.fetchHistories);
  };

  cancelEntry = async (entryId) => {
    const { t, selectedWorkshopId } = this.props;

    try {
      await axios.post(`/uiapi/1/service-book-entries/${entryId}/cancel_entry/?workshop_id=${selectedWorkshopId}`);
      // Refresh the list
      this.fetchEntries();
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : error.message;
      alert(t('error', { ns: 'default' }) + ': ' + errorMessage);
    }
  };

  recoverEntry = async (entryId) => {
    const { t, selectedWorkshopId } = this.props;

    try {
      await axios.post(`/uiapi/1/service-book-entries/${entryId}/recover_entry/?workshop_id=${selectedWorkshopId}`);
      // Refresh the list
      this.fetchEntries();
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : error.message;
      alert(t('error', { ns: 'default' }) + ': ' + errorMessage);
    }
  };

  render() {
    const { t, selectedWorkshopId, user, apiKeyExpired } = this.props;
    const {
      entries,
      loading,
      error,
      selectedFields,
      selectedEntries,
      statusOptions,
      filters,
      historyFilters,
      selectedHistoryFields,
      selectedHistories,
      histories,
      requestServiceHistoryModalIsOpen,
      selectedTab,
      historyStatusOptions,
      selectedMaintenance,
      requestServiceEntryModalIsOpen,
      manufacturerServiceBookEntryModalIsOpen,
      selectedManufacturerServiceBookEntry
    } = this.state;

    if (error) {
      return <div>{t('error', { ns: 'default' })}: {error}</div>;
    }

    const tabMenuItems = [
      { label: t('tabEntries'), icon: 'pi pi-arrow-circle-up', id: 'maintenance-input' },
      { label: t('tabHistory'), icon: 'pi pi-arrow-circle-down', id: 'maintenance-history' },
    ];

    const activeIndex = tabMenuItems.findIndex((item) => item.id === selectedTab);

    const workshop = getCurrentCompany(user, null, selectedWorkshopId, null);

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <div style={getStyle(screenSize, styles, 'filterContainer')}>
                <div style={getStyle(screenSize, styles, 'statusFilter')}>

                  {
                    selectedTab === 'maintenance-input' && (
                      <React.Fragment>
                        <p>{t('headingStatus', { ns: 'TaskListView' })}</p>
                        <MultiSelect
                          value={filters.status}
                          options={statusOptions}
                          onChange={(e) => this.changeFilterTerms({ ...filters, status: e.value })}
                          placeholder={t('selectStatus', { ns: 'default' })}
                          style={{ width: '100%' }}
                          display='chip'
                        />
                      </React.Fragment>
                    )
                  }
                  {
                    selectedTab === 'maintenance-history' && false && (
                      <React.Fragment>
                        <p>{t('headingStatus', { ns: 'TaskListView' })}</p>
                        <MultiSelect
                          value={historyFilters.status}
                          options={historyStatusOptions}
                          onChange={(e) => this.changeHistoryFilterTerms({ ...historyFilters, status: e.value })}
                          placeholder={t('selectStatus', { ns: 'default' })}
                          style={{ width: '100%' }}
                          display='chip'
                        />
                      </React.Fragment>
                    )
                  }

                </div>
                <div style={getStyle(screenSize, styles, 'actionButtonContainer')}>
                  <CBButtonGarageAction
                    onClick={this.openRequestServiceEntryModalClicked}
                    text={t('requestServiceEntry')}
                    mainIcon='/img/icon_dsb.png'
                    disabled={apiKeyExpired}
                    additionalIcon='/img/icon_plus.svg'
                  />
                  <CBButtonGarageAction
                    onClick={this.openRequestServiceHistoryModalClicked}
                    text={t('requestServiceHistory')}
                    disabled={apiKeyExpired}
                    mainIcon='/img/icon_dsb.png'
                  />
                </div>

              </div>
              <hr style={{ opacity: '30%' }} />
            </div>
            <div style={getStyle(screenSize, styles, 'tabMenuContainer')}>
              <TabMenu model={tabMenuItems} activeIndex={activeIndex} onTabChange={this.onTabChange} />
            </div>
            {
              selectedTab === 'maintenance-input' && (
                <React.Fragment>
                <div
                  ref={this.topScrollRef}
                  onScroll={this.handleTopScroll}
                  style={getStyle(screenSize, styles, 'topScrollbar')}
                  className="vehicle-table-scrollbar"
                >
                  <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
                </div>
                <div
                  ref={this.tableScrollRef}
                  onScroll={this.handleTableScroll}
                  style={getStyle(screenSize, styles, 'tableContainer')}
                  className="vehicle-table-scrollbar"
                >
                  <table style={getStyle(screenSize, styles, 'table')}>
                    <thead>
                      <tr>
                        {
                          false && (
                            <th style={styleMerge(getStyle(screenSize, styles, 'tableHeaderFirst'), getStyle(screenSize, styles, 'alignCenter'))}>
                              <CBLabelAndCheckbox
                                checked={selectedEntries.length === entries.length}
                                additionalStyles={{ justifyContent: 'center' }}
                                onChange={this.selectAllChanged}
                              />
                            </th>
                          )
                        }

                        {selectedFields.includes('vehicle') && (
                          <VehicleListTh
                            text={t('headingRegistrationNumber', { ns: 'VehicleListView' })}
                            fieldName='vehicle_registration_number'
                            orderingSymbol={this.getOrderingSymbol('registration_number')}
                            changeOrdering={() => this.changeOrdering('registration_number')}
                          />
                        )}

                        {selectedFields.includes('maintenance') && (
                          <VehicleListTh
                            text={t('headingMaintenance', { ns: 'ManufacturerServiceBook' })}
                            fieldName='maintenance_work_number'
                            orderingSymbol={this.getOrderingSymbol('work_number')}
                            changeOrdering={() => this.changeOrdering('work_number')}
                          />
                        )}

                        {selectedFields.includes('status') && (
                          <VehicleListTh
                            text={t('headingStatus', { ns: 'TaskListView' })}
                            fieldName='status'
                            orderingSymbol={this.getOrderingSymbol('status')}
                            changeOrdering={() => this.changeOrdering('status')}
                          />
                        )}

                        {selectedFields.includes('external_status') && (
                          <VehicleListTh
                            text={t('headingExternalStatus', { ns: 'ManufacturerServiceBook' })}
                            fieldName='external_status'
                            orderingSymbol={this.getOrderingSymbol('external_status')}
                            changeOrdering={() => this.changeOrdering('external_status')}
                          />
                        )}

                        {selectedFields.includes('expires_at') && (
                          <VehicleListTh
                            text={t('headingExpiresAt', { ns: 'ManufacturerServiceBook' })}
                            fieldName='expires_at'
                            orderingSymbol={this.getOrderingSymbol('expires_at')}
                            changeOrdering={() => this.changeOrdering('expires_at')}
                          />
                        )}

                        {selectedFields.includes('actions') && (
                          <VehicleListTh
                            text={t('headingActions', { ns: 'ManufacturerServiceBook' })}
                            fieldName='actions'
                            notSortable
                          />
                        )}

                        <VehicleListTh
                          text={t('headingInputShowEntry', { ns: 'ManufacturerServiceBook' })}
                          fieldName='show_entry'
                          notSortable
                        />

                        <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                          <MultiSelect
                            value={selectedFields}
                            onChange={(e) => this.setSelectedFields(e.value)}
                            options={this.state.fields}
                            className="bars"
                            dropdownIcon={undefined}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {entries.map(entry => (
                        <ManufacturerServiceBookEntryListItem
                          key={entry.id}
                          entry={entry}
                          selectedFields={selectedFields}
                          isSelected={selectedEntries.includes(entry.id)}
                          onSelect={() => this.selectEntry(entry.id)}
                          onUnselect={() => this.unselectEntry(entry.id)}
                          onOpenEntry={this.afterRequestServiceEntry}
                          onCancelEntry={this.cancelEntry}
                          onRecoverEntry={this.recoverEntry}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
                </React.Fragment>
              )
            }
            {
              selectedTab === 'maintenance-history' && (
                <React.Fragment>
                <div
                  ref={this.topScrollRef}
                  onScroll={this.handleTopScroll}
                  style={getStyle(screenSize, styles, 'topScrollbar')}
                  className="vehicle-table-scrollbar"
                >
                  <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
                </div>
                <div
                  ref={this.tableScrollRef}
                  onScroll={this.handleTableScroll}
                  style={getStyle(screenSize, styles, 'tableContainer')}
                  className="vehicle-table-scrollbar"
                >
                  <table style={getStyle(screenSize, styles, 'table')}>
                    <thead>
                      <tr>
                        {
                          false && (
                            <th style={styleMerge(getStyle(screenSize, styles, 'tableHeaderFirst'), getStyle(screenSize, styles, 'alignCenter'))}>
                              <CBLabelAndCheckbox
                                checked={selectedEntries.length === entries.length}
                                additionalStyles={{ justifyContent: 'center' }}
                                onChange={this.selectAllChanged}
                              />
                            </th>
                          )
                        }

                        {selectedHistoryFields.includes('vehicle') && (
                          <VehicleListTh
                            text={t('headingRegistrationNumber', { ns: 'VehicleListView' })}
                            fieldName='vehicle_registration_number'
                            orderingSymbol={this.getHistoryOrderingSymbol('registration_number')}
                            changeOrdering={() => this.changeHistoryOrdering('registration_number')}
                          />
                        )}

                        {selectedHistoryFields.includes('status') && (
                          <VehicleListTh
                            text={t('headingStatus', { ns: 'TaskListView' })}
                            fieldName='status'
                            orderingSymbol={this.getHistoryOrderingSymbol('status')}
                            changeOrdering={() => this.changeHistoryOrdering('status')}
                          />
                        )}

                        {selectedHistoryFields.includes('external_status') && (
                          <VehicleListTh
                            text={t('headingExternalStatus', { ns: 'ManufacturerServiceBook' })}
                            fieldName='external_status'
                            orderingSymbol={this.getHistoryOrderingSymbol('external_status')}
                            changeOrdering={() => this.changeHistoryOrdering('external_status')}
                          />
                        )}

                        {selectedHistoryFields.includes('created_at') && (
                          <VehicleListTh
                            text={t('headingCreatedAt', { ns: 'ManufacturerServiceBook' })}
                            fieldName='created_at'
                            orderingSymbol={this.getHistoryOrderingSymbol('created_at')}
                            changeOrdering={() => this.changeHistoryOrdering('created_at')}
                          />
                        )}

                        <VehicleListTh
                          text={t('download', { ns: 'ManufacturerServiceBook' })}
                          fieldName='download'
                          notSortable
                        />

                        <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                          <MultiSelect
                            value={selectedHistoryFields}
                            onChange={(e) => this.setSelectedHistoryFields(e.value)}
                            options={this.state.historyFields}
                            className="bars"
                            dropdownIcon={undefined}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {histories.map(history => (
                        <ManufacturerServiceBookHistoryListItem
                          key={history.id}
                          entry={history}
                          selectedFields={selectedHistoryFields}
                          isSelected={selectedHistories.includes(history.id)}
                          onSelect={() => this.selectHistory(history.id)}
                          onUnselect={() => this.unselectHistory(history.id)}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
                </React.Fragment>
              )
            }
            {
              requestServiceHistoryModalIsOpen && (
                <RequestServiceHistoryModal
                  modalIsOpen={requestServiceHistoryModalIsOpen}
                  closeModal={() => this.setState({ requestServiceHistoryModalIsOpen: false })}
                  afterOpenModal={() => {}}
                  selectedWorkshopId={selectedWorkshopId}
                  fetchHistories={this.fetchHistories}
                  switchToHistoryTab={() => this.setState({ selectedTab: 'maintenance-history' })}
                  user={user}
                />
              )
            }

            {
              requestServiceEntryModalIsOpen && (
                <RequestServiceEntryModal
                  modalIsOpen={requestServiceEntryModalIsOpen}
                  closeModal={() => this.setState({requestServiceEntryModalIsOpen: false})}
                  setSelectedEntry={this.afterRequestServiceEntry}
                  selectedWorkshopId={selectedWorkshopId}
                  user={user}
                />
              )
            }
            {
              manufacturerServiceBookEntryModalIsOpen && selectedManufacturerServiceBookEntry && (
                <ManufacturerServiceBookEntryModal
                  modalIsOpen={manufacturerServiceBookEntryModalIsOpen}
                  closeModal={() => {this.setState({manufacturerServiceBookEntryModalIsOpen: false, selectedManufacturerServiceBookEntry: null, selectedMaintenance: null});this.fetchEntries();this.fetchHistories();}}
                  vehicle={selectedManufacturerServiceBookEntry.vehicle}
                  maintenance={selectedMaintenance}
                  workshop={workshop}
                  manufacturerServiceBookEntry={selectedManufacturerServiceBookEntry}
                  user={user}
                />
              )
            }

          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    actionButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: 30,
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    statusFilter: {
      display: 'flex',
      flexDirection: 'column',
      width: '300px',
      marginTop: 8,
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableHeader: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    tableHeaderFirst: {
      left: 0,
    },
    alignCenter: {
      textAlign: 'center',
    },
    topBarsContainer: {
      paddingLeft: 16,
    },
    tabMenuContainer: {
      paddingLeft: 16,
    },
  },
  medium: {
    table: {},
  },
  small: {
    table: {},
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    service: state.app.service,
  };
}

export default connect(
  mapStateToProps,
  {},
)(withRouter(translate('ManufacturerServiceBook')(ManufacturerServiceBookEntryList)));
